
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/general",
      function () {
        return require("private-next-pages/terms/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/general"])
      });
    }
  